import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';

const FIVE_MIN = 5 * 60 * 1000;

export interface B2CKpis {
  actions_semaine: number;
  actions_30j: number;
  participants_30j: number;
  ca_b2c_30j: number;
}

export function useFormationB2CKpis() {
  return useQuery({
    queryKey: ['formation_b2c_kpis'],
    queryFn: async (): Promise<B2CKpis | null> => {
      const { data, error } = await supabase.from('v_formation_b2c_kpis').select('*').maybeSingle();
      if (error) throw error;
      if (!data) return null;
      const r = data as Record<string, unknown>;
      return {
        actions_semaine: Number(r.actions_semaine ?? 0),
        actions_30j: Number(r.actions_30j ?? 0),
        participants_30j: Number(r.participants_30j ?? 0),
        ca_b2c_30j: Number(r.ca_b2c_30j ?? 0),
      };
    },
    staleTime: FIVE_MIN,
  });
}

export interface B2CRoi {
  action_id: string;
  reference: string;
  formation_id: string | null;
  formation_titre: string | null;
  formateur_id: string | null;
  formateur_nom_complet: string | null;
  date_action: string;
  horaire: string | null;
  lieu: string | null;
  statut: string;
  capacite_max: number;
  prix_unitaire_b2c: number;
  formateur_paiement_type: string;
  formateur_montant_forfait: number | null;
  formateur_pct_ca: number | null;
  nb_participants: number;
  recettes: number;
  remuneration_formateur: number;
  benefice: number;
}

export function useFormationB2CRoi() {
  return useQuery({
    queryKey: ['formation_b2c_roi'],
    queryFn: async (): Promise<B2CRoi[]> => {
      const { data, error } = await supabase
        .from('v_formation_b2c_roi')
        .select('*')
        .order('date_action', { ascending: false })
        .limit(200);
      if (error) throw error;
      return (data ?? []) as unknown as B2CRoi[];
    },
  });
}
